import React, { Suspense, useEffect, useRef } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Layout as AntdLayout } from 'antd'
import { Header } from './Header'
import { Footer } from './Footer'
import { DisclaimerBar } from './DisclaimerBar'
import { CookieConsent } from './CookieConsent'
import { Seo } from 'shared/seo/Seo'

export const Layout: React.FC = React.memo(() => {
    const layoutRef = useRef<HTMLElement | null>(null)
    const location = useLocation()

    useEffect(() => {
        layoutRef.current?.scrollIntoView({ behavior: 'smooth' })
    }, [location])

    // Готовый HTML был на другом языке, чем выбран у посетителя, — скрипт в
    // index.html прятал его до отрисовки приложения (см. rc-wait).
    useEffect(() => {
        document.documentElement.classList.remove('rc-wait')
    }, [])

    return (
        <AntdLayout ref={layoutRef}>
            <Seo />
            <Header />

            <AntdLayout.Content>
                {/* Страницы грузятся отдельными файлами (см. App.tsx).  Пока файл
                    едет, держим высоту — футер не прыгает под шапку. */}
                <Suspense fallback={<div style={{ minHeight: '80vh' }} />}>
                    <Outlet />
                </Suspense>
            </AntdLayout.Content>

            <DisclaimerBar />
            <Footer />
            <CookieConsent />
        </AntdLayout>
    )
})
